/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:43:17
 * @LastEditTime: 2023-02-08 10:46:11
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\work-center\index.js
 * 工作中心
 */
import visitActivityRouter from './modules/visitActivityRouter'
import approvalManageRouter from './modules/approvalManageRouter'
import workReportRouter from './modules/workReportRouter'
import selfReportDataRouter from './modules/selfReportDataRouter'
import visitTargetRouter from './modules/visitTargetRouter'
import dataReportRouter from './modules/dataReportRouter'

const workCenterRouter = [].concat(
  visitActivityRouter,
  approvalManageRouter,
  workReportRouter,
  selfReportDataRouter,
  visitTargetRouter,
  dataReportRouter,
)
export default workCenterRouter
